import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Typography from "material-ui/Typography";
import AddIcon from "material-ui-icons/Add";
import Card, { CardActions, CardContent } from "material-ui/Card";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import DeleteIcon from "material-ui-icons/Delete";
import EditIcon from "material-ui-icons/Edit";
import ArrowUpwardIcon from "material-ui-icons/ArrowUpward";
import MoreVertIcon from "material-ui-icons/MoreVert";
import ArrowDownwardIcon from "material-ui-icons/ArrowDownward";
import Grid from "material-ui/Grid";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/Menu/MenuItem";
import classNames from "classnames";
import "react-html5video/dist/styles.css";
import Loading from "../../../utils/loading/Loading";
import Retry from "../../../utils/retry/Retry";
import poster1 from "../../posterImage/thumb.png";
import VideoChooser from "./video-chooser/VideoChooser";
import {
  getVideosRequest,
  getVideosSuccess,
  getVideosDone,
  addVideosRequest,
  updateVideoRequest,
  deleteVideoRequest,
  incrementVideoIndexRequest,
  decrementVideoIndexRequest,
} from "./actions";

import styles from "./Videos.scss";
import EditVideoDialog from "./EditVideoDialog";

class Videos extends Component {
  static propTypes = {
    videos: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      videos: PropTypes.arrayOf(
        PropTypes.shape({
          videoTitle: PropTypes.string.isRequired,
          description: PropTypes.string,
          poster: PropTypes.string,
          id: PropTypes.string.isRequired,
          file: PropTypes.string.isRequired,
          duration: PropTypes.number,
        })
      ),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getVideosRequest: PropTypes.func.isRequired,
    getVideosSuccess: PropTypes.func.isRequired,
    getVideosDone: PropTypes.func.isRequired,
    addVideosRequest: PropTypes.func.isRequired,
    updateVideoRequest: PropTypes.func.isRequired,
    deleteVideoRequest: PropTypes.func.isRequired,
    incrementVideoIndexRequest: PropTypes.func.isRequired,
    decrementVideoIndexRequest: PropTypes.func.isRequired,
    playlistId: PropTypes.string,
  };

  static defaultProps = {
    playlistId: undefined,
  };

  state = {
    open: false,
    isMobileview: false,
    anchorEl: null,
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
    this.getVideos(this.props.playlistId);
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.playlistId !== this.props.playlistId) {
      this.getVideos(nextProps.playlistId);
    }
  }

  componentWillUnmount() {
    this.props.getVideosDone();
  }

  updateDimensions = () => {
    if (window.innerWidth <= 375) {
      this.setState({ isMobileview: true });
    } else {
      this.setState({ isMobileview: false });
    }
  };

  getVideos = (playlistId) => {
    if (!playlistId || playlistId === "Aucun") {
      this.props.getVideosSuccess([]);
      return;
    }

    const { id: accessToken } = this.props.login.authData;
    this.props.getVideosRequest({ playlistId, accessToken });
  };

  handleRetry = () => {
    this.getVideos(this.props.playlistId);
  };

  deleteVideo = (video) => {
    this.props.deleteVideoRequest(video);
  };

  showVideoActionList = (event) => {
    this.setState({ isShowVideoActionList: !this.state.isShowVideoActionList });
  };

  incrementVideoIndex = (video) => {
    this.props.incrementVideoIndexRequest(video);
  };

  decrementVideoIndex = (video) => {
    this.props.decrementVideoIndexRequest(video);
  };

  handleSave = (videos) => {
    this.props.addVideosRequest(videos);
  };

  toggleVideoChooser = () => {
    this.setState({ open: !this.state.open });
  };

  handleOpenEditDialog = (video) => {
    this.setState({
      selectedVideo: video,
    });
  };

  handleVideoUpdated = (video, data) => {
    this.props.updateVideoRequest(video, data);
  };

  handleCloseEditDialog = () => {
    this.setState({
      selectedVideo: undefined,
    });
  };

  render() {
    const {
      videos: { requesting, successful, error, videos },
    } = this.props;
    const { anchorEl, isMobileview } = this.state;
    return (
      <Fragment>
        <Grid className="mt4" container justify="space-around" spacing={16}>
          {requesting && <Loading size={80} />}
          {error && <Retry message={error} onRetry={this.handleRetry} />}
          {successful && (
            <Card
              className={classNames({
                [styles.card]: true,
                [styles.addCard]: true,
              })}
              onClick={this.toggleVideoChooser}
            >
              <div className={styles.addIcon}>
                <Button className="mt1">
                  <AddIcon color="primary" />
                </Button>
              </div>
              <CardContent>
                <Typography type="headline" component="h2">
                  Nouvelle vidéo
                </Typography>
                <Typography component="p">
                  Ajouter des vidéos à votre playlist
                </Typography>
              </CardContent>
            </Card>
          )}
          {successful &&
            videos.map((video, index) => (
              <Card
                className={classNames({ [styles.cardVideo]: true })}
                key={index}
              >
                <CardContent
                  className={classNames({
                    [styles.contentVideo]: true,
                  })}
                >
                  <div style={{ position: "relative" }}>
                    <video
                      controls={[
                        "PlayPause",
                        "Seek",
                        "Time",
                        "Volume",
                        "Fullscreen",
                      ]}
                      controlsList="nodownload"
                      src={video.file + "#t=4"}
                      poster={
                        video.posterImage === undefined
                          ? poster1
                          : video.posterImage
                      }
                      preload="none"
                      className={styles.videoPlayWrapper}
                    />

                    {/* {video.duration && <Typography component="p" className={styles.videoDuration}>{video.duration}</Typography>} */}
                  </div>
                  <Typography
                    style={{ textAlign: "left" }}
                    type="headline"
                    component="h5"
                    className={"mt1 " + styles.maxTwoLines}
                  >
                    {video.description
                      ? video.description.substring(0, 1).toUpperCase() +
                        video.description.substring(1)
                      : ""}
                  </Typography>
                  {/* <Typography component="p" className={styles.textOverflow}>{video.description}</Typography> */}

                  {!isMobileview && (
                    <CardActions
                      className={styles.actions}
                      disableActionSpacing
                      style={{
                        position: "absolute",
                        bottom: "0px",
                        width: "100%",
                        left: "0",
                      }}
                    >
                      <IconButton
                        aria-label="Monter"
                        onClick={() => this.incrementVideoIndex(video)}
                      >
                        <ArrowUpwardIcon />
                      </IconButton>
                      <IconButton
                        aria-label="Descendre"
                        onClick={() => this.decrementVideoIndex(video)}
                      >
                        <ArrowDownwardIcon />
                      </IconButton>
                      {/* <IconButton
                        aria-label="Éditer"
                        onClick={() => this.handleOpenEditDialog(video)}
                      >
                        <EditIcon />
                      </IconButton> */}
                      <IconButton
                        aria-label="Supprimer"
                        onClick={() => this.deleteVideo(video)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </CardActions>
                  )}

                  {isMobileview && (
                    <CardActions
                      className={styles.actionsInMobileView}
                      disableActionSpacing
                      style={{
                        position: "absolute",
                        bottom: "0px",
                        width: "100%",
                        left: "0",
                      }}
                    >
                      <IconButton
                        aria-label="More"
                        aria-owns={anchorEl ? "videoActionMenu" : null}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="videoActionMenu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}
                      >
                        <MenuItem
                          aria-label="Monter"
                          style={{ fontSize: "15px", padding: "5px 10px" }}
                          onClick={() => this.incrementVideoIndex(video)}
                        >
                          <ArrowUpwardIcon
                            style={{ fontSize: "17px", marginRight: "10px" }}
                          />{" "}
                          Monter
                        </MenuItem>
                        <MenuItem
                          aria-label="Descendre"
                          style={{ fontSize: "15px", padding: "5px 10px" }}
                          onClick={() => this.decrementVideoIndex(video)}
                        >
                          <ArrowDownwardIcon
                            style={{ fontSize: "17px", marginRight: "10px" }}
                          />{" "}
                          Descendre
                        </MenuItem>
                        <MenuItem
                          aria-label="Éditer"
                          style={{ fontSize: "15px", padding: "5px 10px" }}
                          onClick={() => this.handleOpenEditDialog(video)}
                        >
                          <EditIcon
                            style={{ fontSize: "17px", marginRight: "10px" }}
                          />{" "}
                          Éditer
                        </MenuItem>
                        <MenuItem
                          aria-label="Supprimer"
                          style={{ fontSize: "15px", padding: "5px 10px" }}
                          onClick={() => this.deleteVideo(video)}
                        >
                          <DeleteIcon
                            style={{ fontSize: "17px", marginRight: "10px" }}
                          />{" "}
                          Supprimer
                        </MenuItem>
                      </Menu>
                    </CardActions>
                  )}
                </CardContent>
              </Card>
            ))}
        </Grid>
        <VideoChooser
          open={this.state.open}
          handleSave={this.handleSave}
          handleClose={this.toggleVideoChooser}
        />
        <EditVideoDialog
          open={typeof this.state.selectedVideo !== "undefined"}
          video={this.state.selectedVideo}
          handleClose={this.handleCloseEditDialog}
          handleVideoUpdated={this.handleVideoUpdated}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  videos: state.videos,
  login: state.login,
});

export default connect(mapStateToProps, {
  getVideosRequest,
  getVideosSuccess,
  getVideosDone,
  addVideosRequest,
  updateVideoRequest,
  deleteVideoRequest,
  incrementVideoIndexRequest,
  decrementVideoIndexRequest,
})(Videos);



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/Videos.jsx